export default __webpack_public_path__ + "static/media/grafana-icon.58f535ef.png";